export const congrats: string[] = [
  'Кайф!',
  'Круть!',
  'Вау!',
  'Найс!',
  'Любо!',
  'Ух!',
  'Йес!',
  'Да!',
  'Ура!',
  'Бам!',
];
